<template>
  <editor :type="'template'" :templateType="template.type" :initialData="template" @save="save"></editor>
</template>
<script>
  import Editor from '../Experiments/Editor.vue'
  import swal from 'sweetalert2'

  export default {
    components: {
      Editor
    },
    data () {
      return {
        template: {
          type: null,
          name: null,
          tags: [],
          code: null
        }
      }
    },
    mounted() {
      var self = this
      var xhr = new XMLHttpRequest()
      xhr.open('GET', this.$root.apiUrl + 'v1/templates/' + self.$route.params.id)
      xhr.setRequestHeader('Authorization', localStorage.getItem('token'))
      xhr.onload = function () {
        if (xhr.status === 401) self.$router.push({name: 'Login'})
        var response = JSON.parse(xhr.responseText)
        if (xhr.status === 200 && response.response && response.response) {
          if (response.response.code === null) {
            if (response.response.type === 'experiment') response.response.code = {sections:[]}
            else if (response.response.type === 'section') {
              response.response.code = {
                name: null,
                shuffle: false,
                shuffleScreens: false,
                screens: [],
                scripts: {
                  before: null,
                  after: null
                }
              }
            } else if (response.response.type === 'screen') {
              response.response.code = {
                elements: [],
                html: null,
                style: null,
                loop: null,
                scripts: {
                  before: null,
                  after: null
                }
              }
            } else if (response.response.type === 'element') {
              response.response.code = {
                name: null,
                template: null,
                html: '',
                style: '',
                options: {}
              }
            }
          } else {
            response.response.code = JSON.parse(response.response.code)
          }
          self.template = response.response
          if (self.template.tags.length > 0 && self.template.tags[0] !== '') self.template.tags = self.template.tags.split(',')
          else self.template.tags = []
        } else if (xhr.status === 404) {
          self.$router.push({name: 'Templates'})
        } else {
          var message
          if (response.response && response.response[0] && response.response[0].message)
            message = response.response[0].message
          else
            message = 'Unknown error'
          self.showSweetAlertError(message)
        }
      }
      xhr.send()
    },
    methods: {
      save (template) {
        this.template = template
        var self = this
        var formData = new FormData()
        formData.append('admin_id', localStorage.getItem('admin_id'))
        formData.append('name', this.template.name)
        formData.append('tags', this.template.tags)
        formData.append('code', JSON.stringify(this.template.code))
        var xhr = new XMLHttpRequest()
        xhr.open('POST', this.$root.apiUrl + 'v1/templates/' + self.$route.params.id)
        xhr.setRequestHeader('Authorization', localStorage.getItem('token'))
        xhr.onload = function () {
          if (xhr.status === 401) self.$router.push({name: 'Login'})
          var response = JSON.parse(xhr.responseText)
          if (xhr.status === 201) {
            self.notifyVue('top', 'right')
          } else {
            var message
            if (response.response && response.response[0] && response.response[0].message)
              message = response.response[0].message
            else
              message = 'Unknown error'
            self.showSweetAlertError(message)
          }
        }
        xhr.send(formData)
      },
      showSweetAlertError (message) {
        swal({
          title: 'An error occured!',
          text: message,
          type: 'warning',
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Try again',
          cancelButtonClass: 'md-button md-success',
          buttonsStyling: false
        })
      },
      notifyVue (verticalAlign, horizontalAlign) {
        this.$notify(
          {
            message: 'Template saved succesfully.',
            icon: 'edit',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: 'success'
          }
        )
      }
    }
  }
</script>
<style>
</style>
